export enum AppRoutes {
  LANDING_PAGE = 'landing-page',
  DATA_ENTRY_PAGE = 'data-entry-page',
  ADMIN_PAGE = 'admin',
  NOT_AUTHORIZED_PAGE = 'not-authorized',
  PROS_DASHBOARD = 'pros-dashboard',
}
